import { render } from "./CartAccessories.vue.ts?vue&type=template&id=d035e0a6&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartAccessories.vue?vue&type=template&id=d035e0a6&scoped=true&ts=true"
import script from "./CartAccessories.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartAccessories.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartAccessories.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartAccessories.vue?vue&type=script&setup=true&lang=ts"

import "./CartAccessories.vue.scss?vue&type=style&index=0&id=d035e0a6&scoped=true&lang=scss!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartAccessories.vue?vue&type=style&index=0&id=d035e0a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d035e0a6"],['__file',"src/apps/merchant3/components/offers/CartAccessories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d035e0a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d035e0a6', __exports__)) {
    api.reload('d035e0a6', __exports__)
  }
  
  module.hot.accept("./CartAccessories.vue.ts?vue&type=template&id=d035e0a6&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartAccessories.vue?vue&type=template&id=d035e0a6&scoped=true&ts=true", () => {
    api.rerender('d035e0a6', render)
  })

}


export default __exports__